import { PagePlaceholder } from "../components/PagePlaceholder";

export function HomeBriefPage() {
	return (
		<PagePlaceholder
			title="Home Brief"
			subtitle="One paragraph. Plain English. Generated Monday 06:00 your time."
			endpoint="/v1/insights/manufacturer/brief?period=weekly"
			previewQuote={[
				"Last week, your products were considered in 47 scenes across 12 metro areas. Placements of",
				"your Luxarq Downlight grew 18% week-over-week, driven by activity in the commercial",
				"vertical in the Northeast. Your most common competitive substitution was a Photonix Pendant",
				"in 8 cases — down from 11 the previous week. One thing to watch: in the New England market,",
				"lighting-designer-role users are gravitating toward narrow-optic configurations.",
			].join(" ")}
		/>
	);
}
